import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const services = [
  {
    image: '/images/services/service-system.png',
    icon: 'ri-code-s-slash-line',
    color: 'text-emerald-500',
    bg: 'bg-emerald-50',
    border: 'border-emerald-100',
    title: 'システムソフトウェア開発',
    subtitle: 'System Software Development',
    desc: '業務効率化システム、Webアプリケーション、データベース構築など、お客様のニーズに合わせたカスタム開発を提供します。要件定義から設計・開発・テスト・納品まで一貫してサポートします。',
    features: ['業務効率化システム', 'Webアプリケーション開発', 'データベース設計・構築', 'API開発・連携', 'クラウドシステム構築', '既存システムの改修・保守'],
  },
  {
    image: '/images/services/service-app.png',
    icon: 'ri-smartphone-line',
    color: 'text-pink-500',
    bg: 'bg-pink-50',
    border: 'border-pink-100',
    title: 'アプリケーション制作',
    subtitle: 'Application Development',
    desc: 'iOS・Android対応のモバイルアプリ、業務用アプリケーションの企画から開発、配信までワンストップでサポートします。UI/UXデザインにもこだわり、使いやすいアプリを制作します。',
    features: ['iOSアプリ開発', 'Androidアプリ開発', 'クロスプラットフォーム対応', 'UI/UXデザイン', 'アプリストア申請サポート', '運用・保守サポート'],
  },
  {
    image: '/images/services/service-ad.png',
    icon: 'ri-megaphone-line',
    color: 'text-emerald-500',
    bg: 'bg-emerald-50',
    border: 'border-emerald-100',
    title: 'インターネット広告・広告代理',
    subtitle: 'Internet Advertising',
    desc: 'Web広告の企画・運用代行、SNSマーケティング、SEO対策など、デジタルマーケティングを総合的に支援します。データ分析に基づいた効果的な広告戦略をご提案します。',
    features: ['リスティング広告運用', 'SNS広告（Instagram・X・LINE）', 'SEO対策・コンテンツ制作', 'アクセス解析・レポート', 'ランディングページ制作', '広告代理店業務'],
  },
];

const flow = [
  { step: '01', label: 'ヒアリング', desc: 'お客様のご要望・課題を丁寧にお聞きします' },
  { step: '02', label: '提案・見積', desc: '最適なソリューションと費用をご提案します' },
  { step: '03', label: '開発・制作', desc: 'スピーディかつ丁寧に制作を進めます' },
  { step: '04', label: '納品・サポート', desc: '納品後も継続的にサポートいたします' },
];

export default function ServicesPage() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/images/services/service-system.png"
            alt="Services background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-white"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 text-center">
          <p className="text-xs font-semibold tracking-widest text-pink-300 uppercase mb-3">Our Services</p>
          <h1 className="text-4xl md:text-6xl font-black text-white mb-4">サービス</h1>
          <p className="text-white/70 text-base max-w-xl mx-auto">
            ITの力でお客様のビジネスをフレッシュに変革します
          </p>
        </div>
      </section>

      {/* Services */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex flex-col gap-10">
            {services.map((s, idx) => (
              <div
                key={s.title}
                className={`flex flex-col ${idx % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 items-center bg-gray-50 rounded-2xl overflow-hidden border ${s.border}`}
              >
                <div className="md:w-2/5 w-full h-56 md:h-72 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="md:w-3/5 w-full p-8">
                  <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${s.bg} mb-4`}>
                    <i className={`${s.icon} ${s.color} text-2xl`}></i>
                  </div>
                  <p className="text-xs text-gray-400 tracking-widest uppercase mb-1">{s.subtitle}</p>
                  <h2 className="text-xl md:text-2xl font-black text-gray-800 mb-3">{s.title}</h2>
                  <p className="text-gray-500 text-sm leading-relaxed mb-5">{s.desc}</p>
                  <ul className="grid grid-cols-2 gap-2">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-center gap-2 text-xs text-gray-600">
                        <i className={`ri-check-line ${s.color}`}></i>
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Flow */}
      <section className="py-20 bg-gradient-to-b from-pink-50/60 to-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="text-center mb-12">
            <p className="text-xs font-semibold tracking-widest text-emerald-500 uppercase mb-2">Flow</p>
            <h2 className="text-3xl md:text-4xl font-black text-gray-800">ご依頼の流れ</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {flow.map((f) => (
              <div key={f.step} className="bg-white border border-gray-100 rounded-2xl p-6 text-center">
                <p className="text-4xl font-black text-pink-200 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>{f.step}</p>
                <h3 className="font-bold text-gray-800 mb-2">{f.label}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-black text-gray-800 mb-4">まずはお気軽にご相談ください</h2>
          <p className="text-gray-500 text-sm mb-8">お客様のビジネス課題に合わせた最適なソリューションをご提案します</p>
          <Link
            to="/contact"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-gradient-to-r from-pink-400 to-rose-500 text-white font-semibold px-8 py-3.5 rounded-full hover:opacity-90 transition-opacity text-sm"
          >
            <i className="ri-mail-send-line"></i>
            無料相談・お問い合わせ
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
